export default __webpack_public_path__ + "images/apdf.418515f2256f9e83eddad6d2d27031b3.png";